module.exports = __webpack_public_path__ + "static/couture04-sq-53b81badcf30e755286e292d3d479235.png";